import React, { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useContextMenu } from 'react-contexify';
import { useApp } from '../_contexts';
import { MarkerActions } from '../_actions';
import { DefaultTemplate } from '../_helpers';
import { ImageMarker } from './_components';

export function MapPin({ marker, map }) {
  const { editMode, openSidebar } = useApp();
  const markerRef = useRef();
  const dispatch = useDispatch();
  const { items: markerTemplates } = useSelector(
    (state) => state.markerTemplates
  );

  let { template } = { ...marker };

  if (template !== null && typeof template === 'string') {
    template = markerTemplates.find((i) => i._id === template);
    if (!template) {
      template = new DefaultTemplate();
    }
  } else if (template !== null && template._id) {
    template = markerTemplates.find((i) => i._id === template._id);
    if (!template) {
      template = new DefaultTemplate();
    }
  } else {
    if (template === null || !template._id) {
      template = new DefaultTemplate();
    }
  }

  const handleClick = (ev) => {
    openSidebar({
      type: 'locationMarker',
      payload: { marker },
    });
  };

  const handleDragUpdate = (ev) => {
    if (editMode) {
      const newPos = ev.target.getLatLng();
      const updatedMarker = {
        ...marker,
        coords: {
          ...marker.coords,
          x: newPos.lng,
          y: newPos.lat,
        },
      };

      dispatch(MarkerActions.updateMarker(updatedMarker, marker._id));
    }
  };

  const { show } = useContextMenu({
    id: 'chronos-map-pin-context-menu',
    props: {},
  });

  const handleContextClick = (ev) => {
    ev.originalEvent.preventDefault();
    ev.originalEvent.stopPropagation();
    if (editMode) {
      show(ev.originalEvent, {
        props: {
          marker,
          map,
        },
      });
      ev.originalEvent.stopPropagation();
    }
  };

  const mapMethods = {
    contextmenu: handleContextClick,
    click: handleClick,
    dragend: handleDragUpdate,
  };

  return template && template.mode === 'image' ? (
    <ImageMarker
      marker={{ ...marker }}
      template={{ ...template }}
      methods={mapMethods}
      editMode={editMode}
      innerRef={markerRef}
    />
  ) : null;

  // if (!customIcon) {
  //   icon = L.icon({
  //     iconUrl: IconLibrary.default,
  //     iconSize: [25, 41],
  //     iconAnchor: [12.5, 40],
  //   });
  // } else {
  //   console.log('TT: ', template, { ...marker });
  //   if (template && typeof template.pinImg === 'string') {
  //     console.log('Pin Image lookup required!');
  //     const templateImage = markerImages.find((i) => i._id === template.pinImg);
  //     if (templateImage) {
  //       template.pinImg = templateImage;
  //     } else {
  //       template.pinImg = DEFAULT_MARKER_IMAGE;
  //     }
  //   } else if (
  //     template === null &&
  //     templateOverrides &&
  //     typeof templateOverrides.pinImg === 'string'
  //   ) {
  //     const templateImage = markerImages.find(
  //       (i) => i._id === templateOverrides.pinImg
  //     );
  //     if (templateImage) {
  //       templateOverrides.pinImg = templateImage;
  //     } else {
  //       template.pinImg = DEFAULT_MARKER_IMAGE;
  //     }
  //   } else {
  //     templateOverrides.pinImg = DEFAULT_MARKER_IMAGE;
  //   }
  //   console.log('MARKER', marker);
  //   console.log('BASE TEMPLATE', template);
  //   console.log('OVERRIDES', templateOverrides);
  //   const renderTemplate = generateTemplateStyle(template, templateOverrides);
  //   const newMarker = generateMarkerImage(renderTemplate, marker);

  //   const { width, height, anchorX, anchorY, tooltipEnabled } = renderTemplate;
  //   isTooltipVisible = tooltipEnabled;
  //   // offsets = [0, (height - anchorY) * -1];
  //   offsets = [width / 2 - anchorX, (height - anchorY) * -1];
  //   // console.log(renderToString(newMarker));
  //   icon = L.divIcon({
  //     html: renderToString(newMarker),
  //     iconSize: [width, height],
  //     iconAnchor: [anchorX, anchorY],
  //     className: `chronos-custom-marker chronos-marker-${marker._id}`,
  //   });

  // <Marker
  //   position={[coords.y, coords.x]}
  //   // title={marker.title}
  //   icon={icon}
  //   color={marker.color}
  //   ref={markerRef}
  //   eventHandlers={{
  //     contextmenu: handleContextClick,
  //     click: handleClick,
  //     dragend: handleDragUpdate,
  //   }}
  //   riseOnHover={options.rise}
  //   riseOffset={options.rise ? options.riseOffset : undefined}
  //   opacity={options.opacity}
  //   zIndexOffset={options.zIndex}
  //   draggable={editMode}
  //   style={{ color: options.textColor, backgroundColor: options.color }}
  // >
  //   {/* {options.showTitlePopup && <Popup>{marker.title}</Popup>} */}
  //   {isTooltipVisible && (
  //     <Tooltip direction="top" offset={offsets}>
  //       {marker.title}
  //     </Tooltip>
  //   )}
  // </Marker>
}
